import React from 'react';
import { SearchCourses } from '../common/SearchCourses';
import { BackgroundPicture } from '../html5/BackgroundPicture';
import { PageBannerProps } from '../page-banner/PageBanner';

interface HomeBannerProps {
    pageBanner: PageBannerProps;
    searchPath: {
        autocompleteApiPath: string;
        searchPath: string;
    };
}

const HomeBanner: React.FC<HomeBannerProps> = ({ pageBanner, searchPath }) => {
    return (
        <BackgroundPicture
            {...pageBanner.image}
            className={pageBanner.className}
            defaultImage={pageBanner.defaultImage}
            allowOverflow={true}
            omitAlt // The text overlay (name) makes the alt redundant
            data-testid="banner-image"
        >
            <div className="container-fluid">
                <div className="row">
                    <div className="d-flex flex-column justify-content-center home-banner-content col-md-6 mx-auto mt-4 p-5 px-md-2 text-center text-shadow text-white">
                        <h1 className="page-banner-name font-weight-normal mb-3 pt-5" data-testid="banner-name">
                            {pageBanner.name}
                        </h1>
                        <div className="page-banner-description font-weight-light h4" data-testid="banner-description">
                            {pageBanner.description}
                        </div>
                    </div>
                </div>
                <div className="row bg-home-search">
                    <div className="d-flex flex-column justify-content-center mx-auto my-4 col-md-6">
                        <SearchCourses
                            {...searchPath}
                            useHomePageSettings
                            className="pt-4 pb-4"
                            id="home-search-courses"
                        />
                    </div>
                </div>
            </div>
        </BackgroundPicture>
    );
};

export { HomeBanner, HomeBannerProps };
